import { connect } from 'react-redux';
import TRCAudioView from './TRCAudioView';
import { stopAudio } from '../../common/audio/audioActions';
import { setIsFileLoadingFailed } from '../../common/screen/screenActions';
import selectors from '../../rootSelectors';

const mapStateToProps = state => ({
    ...state.audio,
    assessment: selectors.getNextIncompleteMeasure(state),
});

const mapDispatchToProps = dispatch => ({
    stopAudio: () => {
        dispatch(stopAudio());
    },
    onAudioLoadingError: () => {
        dispatch(setIsFileLoadingFailed(true));
    },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const reduxOnEndCallback = stateProps.onEndCallback;
    const customOnEndCallback = ownProps.onEndCallback;
    const reduxOnPlayCallback = stateProps.onPlayCallback;
    const customOnPlayCallback = ownProps.onPlayCallback;

    // Merge both onEndCallback functions if both exist
    const mergedOnEndCallback =
        reduxOnEndCallback || customOnEndCallback
            ? (...args) => {
                  if (reduxOnEndCallback) reduxOnEndCallback(...args);
                  if (customOnEndCallback) customOnEndCallback(...args);
              }
            : undefined;

    // Merge both onPlayCallback functions if both exist
    const mergedOnPlayCallback =
        reduxOnPlayCallback || customOnPlayCallback
            ? (...args) => {
                  if (reduxOnPlayCallback) reduxOnPlayCallback(...args);
                  if (customOnPlayCallback) customOnPlayCallback(...args);
              }
            : undefined;

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        onEndCallback: mergedOnEndCallback,
        onPlayCallback: mergedOnPlayCallback,
    };
};

const TRCAudioContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(TRCAudioView);

export default TRCAudioContainer;
